import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=63d33920"
import script from "./Service.vue?vue&type=script&lang=js"
export * from "./Service.vue?vue&type=script&lang=js"
import style0 from "./Service.vue?vue&type=style&index=0&id=63d33920&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports